import api, { buildAuthWizardUrl } from './client';

export const logoutUser = async () => {
  const response = await api.post(buildAuthWizardUrl('/logout'), {});
  return response.data;
};

export const fetchCurrentUser = async () => {
  const response = await api.get(buildAuthWizardUrl('/me'));
  return response.data;
};

export async function changePassword(body: { oldPassword: string; newPassword: string }) {
  const response = await api.post(buildAuthWizardUrl('/change-password'), body);
  return response.data as { message?: string };
}

export const changeSitePreference = async (site: string) => {
  const response = await api.post(buildAuthWizardUrl('/me/site-preference'), { site_name: site });
  return response.data;
};
